import { render, staticRenderFns } from "./MenuIconPicker.vue?vue&type=template&id=bbe0acac&scoped=true"
import script from "./MenuIconPicker.vue?vue&type=script&lang=js"
export * from "./MenuIconPicker.vue?vue&type=script&lang=js"
import style0 from "./MenuIconPicker.vue?vue&type=style&index=0&id=bbe0acac&prod&scoped=true&lang=css"
import style1 from "./MenuIconPicker.vue?vue&type=style&index=1&id=bbe0acac&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe0acac",
  null
  
)

export default component.exports